import { render, staticRenderFns } from "./checkAccess.vue?vue&type=template&id=d123f518&"
import script from "./checkAccess.vue?vue&type=script&lang=js&"
export * from "./checkAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports